import React from 'react';

import './withFormContainer.css';

function withFormContainer(Component) {

    return class FormContainer extends React.Component {

        state = {
            loading: false
        };

        componentDidMount() {
            this.props.sendResizeEvent();
        }

        changeLoading = loading => {

            return new Promise(resolve => {

                this.setState({ loading }, resolve);
            });
        };

        render() {

            const style = {};
            if (this.props.popupBackgroundColor) {
                style.backgroundColor = this.props.popupBackgroundColor;
            }
            if (this.props.popupTextColor) {
                style.color = this.props.popupTextColor;
            }

            return (
                <div style={style} className={`form-container${this.state.loading ? ' loading' : ''}`}>

                    <div className="close-container">
                        <button value={this.props.closeValue} onClick={this.props.close}>
                            <span className="icon-close" />
                        </button>
                    </div>
                    <div className="form-body">

                        <Component
                            {...this.props}
                            loading={this.state.loading}
                            changeLoading={this.changeLoading}
                        />

                        <div className="loader-container">
                            <div className="loader" />
                        </div>

                    </div>

                </div>
            );
        }
    };
}

export default withFormContainer;


// WEBPACK FOOTER //
// ./src/components/withFormContainer.jsx